
    const html = "<div class=tooltip-arrow></div> <div class=tooltip-inner uib-tooltip-template-transclude=contentExp() tooltip-template-transclude-scope=originScope()></div> ";
    angular.module('ng').run(['$templateCache', function($templateCache){
      $templateCache.put('uib/template/tooltip/tooltip-template-popup.html', html);
    }]);
    module.exports = 'uib/template/tooltip/tooltip-template-popup.html';
  